import React from "react";
import { Helmet } from 'react-helmet';
import { useState } from "react";
import axios from "axios";
import { buildApiUrl } from "../utils/api";
function CreateWarehouse() {
    const [name, setName] = useState('');
    const [website, setWebsite] = useState('');
    const [locations, setLocations] = useState('');
    const [totalArea, setTotalArea] = useState('');
    const [services, setServices] = useState('');
    const [products, setProducts] = useState('');
    const [description, setDescription] = useState('');
    const [summary, setSummary] = useState('');
    const [image, setImage] = useState(null);

    const handleSubmit = async (event) => {
        event.preventDefault();

        const formData = new FormData();
        formData.append('name', name);
        formData.append('website', website);
        formData.append('locations', locations);
        formData.append('totalArea', totalArea);
        formData.append('services', services);
        formData.append('products', products);
        formData.append('description', description);
        formData.append('summary', summary);
        if (image) {
            formData.append('image', image);
        }

        try {
            await axios.post(buildApiUrl('/api/warehouses/create'), formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            alert('Warehouse created successfully');
            setName("");
            setWebsite("");
            setLocations("");
            setTotalArea("");
            setServices("");
            setProducts("");
            setDescription("");
            setSummary("");
            setImage(null);
        } catch (error) {
            alert('Error creating Warehouse', error);
        }
    };
    return (
        <>
            <Helmet>
                <title>Create Warehouse | 3pl Site</title>
            </Helmet>
            <div className="createWarehouse">
                <h1>CREATE NEW WAREHOUSE</h1>
                <div className=" container blogForm shadow-lg mb-5" style={{ width: "50%", borderRadius: "30px" }}>
                    <form className="text-start py-5 px-4" onSubmit={handleSubmit}>
                        <div class="mb-3">
                            <label class="form-label" style={{ fontWeight: "bold" }}>Warehouse Name</label>
                            <input
                                type="text"
                                className="form-control"
                                id="warehouseName"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                required
                            />
                        </div>
                        <div class="mb-3">
                            <label class="form-label" style={{ fontWeight: "bold" }}> Firm Website</label>
                            <input
                                type="text"
                                className="form-control"
                                id="firmWebsite"
                                value={website}
                                onChange={(e) => setWebsite(e.target.value)}
                                required
                            />
                        </div>
                        <div class="mb-3">
                            <label class="form-label" style={{ fontWeight: "bold" }}>Locations</label>
                            <input
                                type="text"
                                className="form-control"
                                id="location"
                                value={locations}
                                onChange={(e) => setLocations(e.target.value)}
                                required
                            />
                        </div>
                        <div class="mb-3">
                            <label class="form-label" style={{ fontWeight: "bold" }}>Services Provided</label>
                            <input
                                type="text"
                                className="form-control"
                                id="services"
                                value={services}
                                onChange={(e) => setServices(e.target.value)}
                                required
                            />
                        </div>
                        <div class="mb-3">
                            <label class="form-label" style={{ fontWeight: "bold" }}>Products Dealing</label>
                            <input
                                type="text"
                                className="form-control"
                                id="products"
                                value={products}
                                onChange={(e) => setProducts(e.target.value)}
                                required
                            />
                        </div>
                        <div class="mb-3">
                            <label class="form-label" style={{ fontWeight: "bold" }}>Total Area Space (Sq.ft)</label>
                            <select
                                className="form-control"
                                id="services"
                                value={totalArea}
                                onChange={(e) => setTotalArea(e.target.value)}
                                required
                            >
                                <option value="">Select an area</option>
                                <option value="0-25,000">0-25,000 Sq.ft</option>
                                <option value="25,001-50,000">25,001-50,000 Sq.ft</option>
                                <option value="50,001-75,000">50,001-75,000 Sq.ft</option>
                                <option value="75,001-100,000">75,001-100,000 Sq.ft</option>
                                <option value="100,001-125,000">100,001-125,000 Sq.ft</option>
                                <option value="125,001-150,000">125,001-150,000 Sq.ft</option>
                                <option value="150,001-175,000">150,001-175,000 Sq.ft</option>
                                <option value="175,001-200,000">175,001-200,000 Sq.ft</option>
                            </select>
                        </div>

                        <div class="mb-3">
                            <label class="form-label" style={{ fontWeight: "bold" }}>Short Description</label>
                            <textarea
                                className="form-control"
                                id="warehouseDescription"
                                value={description}
                                onChange={(e) => setDescription(e.target.value)}
                                required
                            />
                        </div>
                        <div class="mb-3">
                            <label class="form-label" style={{ fontWeight: "bold" }}>Brief Summary of Warehouse</label>
                            <textarea
                                className="form-control"
                                id="warehouseSummary"
                                value={summary}
                                onChange={(e) => setSummary(e.target.value)}
                                required
                            />
                        </div>
                        <div className="mb-3">
                            <label class="form-label" style={{ fontWeight: "bold" }}>Upload Warehouse Logo</label>
                            <input
                                type="file"
                                className="form-control"
                                id="blogImage"
                                onChange={(e) => setImage(e.target.files[0])}
                            />
                            <p style={{color:"#973131"}}>upload image size of 600 X 300 px</p>
                        </div>
                        <div className="d-flex justify-content-center">
                            <button type="submit" class="btn btn-primary">Submit</button>
                        </div>
                    </form>
                </div>
            </div>
        </>
    )
}
export default CreateWarehouse
